import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import JoinCellcomTvBlockData from '../../../Models/Content/JoinCellcomTvBlockData';
import JoinCellcomTvComponent from './JoinCellcomTvComponent';

export default class JoinCellcomTvBlock extends EpiComponent<JoinCellcomTvBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['join-cellcom-tv-block'];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(' ')}>
        <JoinCellcomTvComponent className='join-cellcom-tv-component' iContent={this.props.data} context={this.getContext()} />
      </div>
    );
  }
}
